import React, { useState, useEffect } from 'react';
import { NavLink, useSearchParams, useNavigate } from "react-router-dom";
import moment from 'moment';
import axios from 'axios';
import styled from 'styled-components';
import LoggedLayout from 'layouts/LoggedLayout';
import Paginator from 'components/Paginator';
import ThSortable from 'components/ThSortable';
import TrSkeleton from 'components/TrSkeleton';
import { getCommunity } from 'helpers/community';

const Table = styled.table`
	tbody > tr {
		cursor: pointer;
	}

	th,
	td {
		&:nth-child(2),
		&:nth-child(3),
		&:nth-child(4) {
			width: 100px;
		}

		&:nth-child(5) {
			width: 40px;
		}
	}	

`;

let axiosCancelToken = null;
let searchTimeout = null;

export default function AppOwnersBulletinBoard() {
	const [queryParams] = useSearchParams();
	let navigate = useNavigate();

	let [announcements, setAnnouncements] = useState({});
	let [search, setSearch] = useState(undefined);
	let [sortDirection, setSortDirection] = useState('desc');
	let [sortField, setSortField] = useState('date_from');
	let [skeletonRows, setSkeletonRows] = useState(5);
	let [page, _setPage] = useState(queryParams.get('page') ?? undefined);
	const setPage = (page) => {
		setAnnouncements({...announcements, data: undefined});
		_setPage(page);
	}

	const setSearchTimeout = (value) => {
		if ( searchTimeout ) clearTimeout(searchTimeout);
		searchTimeout = setTimeout(() => {
			setSearch(value);
			setPage(1);
		}, 1000);
	}

	const sortTableClick = (field) => {
		if ( !field ) return;
		if ( field === sortField ) setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
		setSortField(field);
	};

	useEffect(() => {
		axiosCancelToken = axios.CancelToken.source();
	
		return function cleanup() {
           	axiosCancelToken.cancel();
        }
	}, []);

	useEffect(() => {
		const getAnnouncements = async () => {
			await axios.get('/api/manager/appowners-bulletinboard/list', {
				params: {
					page: page,
					search: search,
					sort: sortField,
					direction: sortDirection,
					community_id: getCommunity()?.id,
				},
				cancelToken: axiosCancelToken.token
			}).then((response) => {
		    	setAnnouncements({...response.data});
		    	setSkeletonRows(response.data.data.length);
		  	}).catch((error) => {
				if ( axios.isCancel(error) ) return;
			});	
		}

		getAnnouncements();
	}, [page, search, sortField, sortDirection]);

	return (
		<LoggedLayout>
			<section>
				<div className="page-title">
					<h1>Tablón de anuncios del portal de propietarios</h1>
					
					<NavLink to="/appowners-bulletinboard/add" className="btn btn-sm btn-light ms-auto">Nuevo anuncio</NavLink>
				</div>

				<div className="page-content">
					<div className="card border-0 shadow-sm">
						<div className="card-header bg-white p-3">
							<div className="row">
								<div className="col-md-3 mb-2 mt-2 mb-md-0 mt-md-0">
									<input type="search" className="form-control form-control-sm" placeholder="Buscar" onChange={(e) => setSearchTimeout(e.target.value)} />
								</div>
								<div className="col-md-2 mb-2 mt-2 mb-md-0 mt-md-0">
									
								</div>
								<div className="col-md-7 mb-2 mt-2 mb-md-0 mt-md-0 text-end">
									
								</div>
							</div>
						</div>
						<div className="card-body p-0">
							<div className="table-responsive table-responsive-carded">
								<Table className="table table-hover table-sortable table-carded">
									<thead>
										<tr>
											<ThSortable direction={sortDirection} active={sortField === 'description'} onClick={() => sortTableClick('description')}>Anuncio</ThSortable>
											<ThSortable direction={sortDirection} active={sortField === 'date_from'} onClick={() => sortTableClick('date_from')}>Desde</ThSortable>
											<ThSortable direction={sortDirection} active={sortField === 'date_to'} onClick={() => sortTableClick('date_to')}>Hasta</ThSortable>
											<th>Estado</th>
											<th style={{width: '40px'}}></th>
										</tr>
									</thead>
									<tbody>
										{ announcements.data?.length > 0 &&
											announcements.data.map((el, idx) => {
												return ( 
													<React.Fragment key={'c'+idx}>
														<tr onClick={() => navigate('/appowners-bulletinboard/edit/' + el.id)}>
															<td>{el.description ?? '-'}</td>
															<td>{ moment(el.date_from).format('DD-MM-YYYY') }</td>
															<td>{ moment(el.date_to).format('DD-MM-YYYY') }</td>
															<td>
																<div className={'text-white text-center bg-' + (el.status ? 'success' : 'danger')}>
																	{ el.status ? 'Activo' : 'Inactivo' }
																</div>	
															</td>
															<td>
																<NavLink className="btn-table" to={'/appowners-bulletinboard/edit/' + el.id}><i className="bi bi-pencil"></i></NavLink>
															</td>
														</tr>
													</React.Fragment>
												);
											})
										}

										{ announcements.data && !announcements.data.length && <tr><td colSpan="100%">No hay datos disponibles</td></tr> }

										{ announcements.data === undefined && <TrSkeleton rows={skeletonRows} columns={5} /> }
									</tbody>
								</Table>
							</div>
						</div>
						<div className="card-footer p-3 d-flex justify-content-end">
							<div className="d-inline-block">
								<Paginator
									min={1}
									current={announcements?.current_page}
									max={announcements?.last_page}
									changeCallback={(page) => setPage(page)}
								/>
							</div>
						</div>
					</div>
				</div>
			</section>
		</LoggedLayout>
	);
}


